// AFBBadgeMovementCard.tsx
// Affiche un mouvement rattaché à une activité

import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
	faArrowAltCircleRight,
	faArrowAltCircleLeft,
	faTrashAlt,
	faPen,
} from '@fortawesome/free-solid-svg-icons';

import { formatLocalDateTime } from 'common';
import { BadgeMovementData } from 'features/badgeMovement';

interface Props {
	movement: BadgeMovementData;
	onRemove: () => void;
}

const AFBBadgeMovementCard: React.FC<Props> = ({ movement, onRemove }) => {
	const formatOwnerLastName = (name?: string) => {
		if (!name) return '';
		const upper = name.toUpperCase();
		if (upper.length > 10) {
			return upper.slice(0, 10) + '.';
		}
		return upper;
	};

	return (
		<div
			style={{
				display: 'flex',
				alignItems: 'center',
				gap: 8,
			}}
		>
			{movement.direction === 'IN' ? (
				<FontAwesomeIcon icon={faArrowAltCircleRight} color="#28a745" />
			) : (
				<FontAwesomeIcon icon={faArrowAltCircleLeft} color="#dc3545" />
			)}

			{
				<span className="text-gray-500">
					{formatLocalDateTime(movement.dateTime)}
				</span>
			}

			<span
				className="text-gray-500"
				title={
					movement.badgeNumber +
					' : ' +
					movement.ownerLastName +
					' ' +
					movement.ownerFirstName +
					'. Société : ' +
					movement.company +
					'. Affaire : ' +
					movement.project
				}
			>
				{movement.badgeNumber}
				{' ' + formatOwnerLastName(movement.ownerLastName)}
			</span>

			<a
				href={`/app/badgeMovements/${movement.id}/edit`}
				target="_blank"
				rel="noopener noreferrer"
				title="Aller à la fiche du badge (ouvre dans un nouvel onglet)"
			>
				{' '}
				<FontAwesomeIcon
					icon={faPen}
					className="w-4 h-4 text-gray-400 hover:text-[#d400ff] ml-2 cursor-pointer"
				/>
			</a>

			<button
				onClick={(e) => {
					e.stopPropagation();
					onRemove();
				}}
				className="text-gray-400 hover:text-[#d400ff]"
				title="Supprimer ce mouvement de badge de l'activité (le renvoie dans la Pool)"
			>
				<FontAwesomeIcon icon={faTrashAlt} size="sm" />
			</button>
		</div>
	);
};

export default AFBBadgeMovementCard;
